import { render, staticRenderFns } from "./CytomineTags.vue?vue&type=template&id=a3bd014e&scoped=true&"
import script from "./CytomineTags.vue?vue&type=script&lang=js&"
export * from "./CytomineTags.vue?vue&type=script&lang=js&"
import style0 from "./CytomineTags.vue?vue&type=style&index=0&id=a3bd014e&scoped=true&lang=css&"
import style1 from "./CytomineTags.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bd014e",
  null
  
)

export default component.exports